import { render, staticRenderFns } from "./MigrateChatV2.vue?vue&type=template&id=415d053e&scoped=true"
import script from "./MigrateChatV2.vue?vue&type=script&lang=js"
export * from "./MigrateChatV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415d053e",
  null
  
)

export default component.exports